import { selectBonuses } from "@/entities/bonus"
import { selectPairs, selectPairsLoading } from "@/entities/trading"
import { ITradingPair } from "@/shared/api/trading"
import { useAppSelector } from "@/shared/lib/redux"
import { Table } from "@/shared/ui/table"
import BonusSvg from '@/shared/assets/images/BonusMenuIcon.svg'
import { Link } from "react-router-dom"
import { ColumnDef } from "@tanstack/react-table"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { toLocaleString } from "@/shared/lib/to-locale-string"
import { useMemo } from "react"

export const PairsTable = () => {
    const pairs = useAppSelector(selectPairs)
    const bonuses = useAppSelector(selectBonuses)
    const isLoading = useAppSelector(selectPairsLoading)

    const parsedPairs = useMemo(() => pairs.filter(pair => pair.is_active), [pairs])

    const columns: ColumnDef<ITradingPair, any>[] = [
        {
            accessorFn: (pair) => pair,
            id: 'name',
            enableSorting: false,
            cell: info => {
                const pair = info.getValue()
                const bonus = bonuses.find(bonus => bonus.id === pair.bonus1_id)
                return (
                    <div>
                        <div className="flex gap-2 items-center">
                            <div className="w-9 h-9 relative shrink-0">
                                <div className="w-full h-full border border-[#E7EAEE] rounded-full overflow-hidden">
                                    <img
                                        className="w-full h-full object-contain"
                                        src={bonus?.image}
                                    />
                                </div>
                                <div className="rounded-full top-0 right-0 z-10 absolute bg-color-primary border border-[#E7EAEE] w-[13px] h-[8px] flex items-center justify-center">
                                    <div className="text-white text-[3.5px] font-bold leading-[3.5px]">
                                        соц
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col gap-[2px]">
                                <div className="text-lg font-semibold uppercase">
                                    {pair.name}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            },
            header: () => <div className="!text-start text-nowrap">Название</div>,
        },
        {
            accessorFn: (pair) => (
                <div className="!text-end">
                    {toLocaleString(pair.current_sell_quantity) || '0'}
                </div>
            ),
            enableSorting: false,
            id: 'amount',
            cell: info => info.getValue(),
            header: () => <div className="!text-end w-full text-nowrap">Обьем бонусов</div>,
        },
        {
            accessorFn: (pair) => pair,
            id: 'price',
            cell: info => {
                const pair: ITradingPair = info.getValue()
                return (
                    <div className="w-fit ml-3">
                        <div className="flex items-center gap-[6px] py-[6px] px-3 bg-color-body rounded-full">
                            <div className="text-color-dark font-extrabold">
                                {pair.price ?? 1}
                            </div>
                            <div className="fill-color-dark text-color-primary">
                                <BonusSvg width={24} height={24} />
                            </div>
                        </div>
                    </div>
                )
            },
            meta: {
                cellProps: {
                    className: 'w-full [&_div]:!justify-start'
                }
            },
            sortingFn: (a, b): number => {
                return a.original.price > b.original.price ? 1 : -1
            },
            header: () => <div className="!text-center ml-3 text-nowrap">Курс к Бонусу</div>,
        },
        {
            accessorFn: (pair) => (
                <div className="!text-end">
                    <Link to={`/social-market/pair/${pair.id}`} className="text-white text-[13px] font-semibold bg-color-primary rounded-full px-3 py-[6px]">
                        ОБМЕНЯТЬ
                    </Link>
                </div>
            ),
            enableSorting: false,
            id: 'exchange',
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap"></div>,
        },
    ]

    return (
        <>
            {Boolean(parsedPairs.length) &&
                <div className="p-3 bg-white rounded-2xl no-scrollbar overflow-hidden overflow-y-auto screen:rounded-3xl">
                    <Table
                        columns={columns}
                        data={parsedPairs}
                        classNames={{
                            thead: 'table table-fixed w-full',
                            tbody: 'max-h-[640px] overflow-y-scroll block [&_tr]:table [&_tr]:table-fixed [&_tr]:w-full !w-full'
                        }}
                    />
                </div>
            }
            {(!Boolean(parsedPairs.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(parsedPairs.length) && !isLoading) &&
                <NoTableData label="Нет данных о торговых парах" />
            }
        </>
    )
}